import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageClaim, LossAndDamageSearchFilters } from '@/views/screens/Claims/types';

export interface ClaimsListBasicRequestParams
  extends Omit<LossAndDamageSearchFilters, 'startDate' | 'endDate' | 'claimStatus'> {
  claimStatus: string; // comma-separated string
  daysOld?: string;
}

export interface ClaimsListResponse {
  claimsData: LossAndDamageClaim[];
  footerData: {
    totalClaim: number;
    openClaim: number;
    closedClaim: number;
    holdClaim: number;
    filedAmount: number;
    paidAmount: number;
    preClaim?: number;
  };
  nextPage?: number;
}

export const getClaimsListBasicAPI = (params: ClaimsListBasicRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetBasicClaimSearch`,
  });
};

export const fetchClaimsListBasic = async (params: ClaimsListBasicRequestParams): Promise<ClaimsListResponse> => {
  const response: AxiosResponse<ClaimsListResponse> = await getClaimsListBasicAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize) || 1;
  const totalClaims = Number(data.footerData?.totalClaim ?? 0);
  const totalPages = Math.ceil(totalClaims / pageSize);
  const hasMore = Number(params.pageNo) < totalPages;

  return {
    ...data,
    nextPage: hasMore ? Number(params.pageNo) + 1 : undefined,
  };
};
